/** @format */

const template = `
<div ng-switch="$ctrl.searchFilterType">
  <search-filter-date
    ng-switch-when="Date"
    filter-name="$ctrl.filterName"
    cloned-parameter-model="$ctrl.clonedParameterModel"
    popover-is-open="$ctrl.popoverIsOpen"
    submit-filter="$ctrl.submitFilter()"
    min-date="'1900-01-01'">
  </search-filter-date>

  <search-filter-date-range
    ng-switch-when="DateRange"
    cloned-parameter-model="$ctrl.clonedParameterModel"
    filter-name="$ctrl.filterName"
    on-date-range-change="$ctrl.onDateRangeChange()"
    popover-is-open="$ctrl.popoverIsOpen"
    submit-filter="$ctrl.submitFilter()"></search-filter-date-range>

  <search-filter-sales-period
    ng-switch-when="SalesPeriod"
    cloned-parameter-model="$ctrl.clonedParameterModel"
    filter-name="$ctrl.filterName"
    popover-is-open="$ctrl.popoverIsOpen"
    submit-filter="$ctrl.submitFilter()"></search-filter-sales-period>

  <sis-search-filter-education
    ng-switch-when="Education"
    [filter-name]="$ctrl.filterName"
    [get-educations]="$ctrl.getEducations"
    [get-filter-name]="$ctrl.getFilterName"
    [list-selected]="$ctrl.listSelected"
    (open-education-modal)="$ctrl.openEducationModal()"
    [popover-is-open]="$ctrl.popoverIsOpen"
    [selected-education]="$ctrl.selectedEducation"
    (submit-filter)="$ctrl.submitFilter()"
    (toggle-child-value)="$ctrl.toggleChildValue($event.value, $event.childValue, $event.form, $event.event)"
    (toggle-value)="$ctrl.toggleValue($event.value, $event.form, $event.event)"></sis-search-filter-education>

  <sis-search-filter-course-unit
    ng-switch-when="CourseUnit"
    [filter-name]="$ctrl.filterName"
    [get-course-units]="$ctrl.getCourseUnits"
    [get-filter-name]="$ctrl.getFilterName"
    [list-selected]="$ctrl.listSelected"
    [popover-is-open]="$ctrl.popoverIsOpen"
    [selected-course-unit]="$ctrl.selectedCourseUnit"
    (submit-filter)="$ctrl.submitFilter()"
    (toggle-value)="$ctrl.toggleValue($event.value, $event.form, $event.event)"></sis-search-filter-course-unit>

  <sis-search-filter-module
    ng-switch-when="Module"
    [filter-name]="$ctrl.filterName"
    [get-filter-name]="$ctrl.getFilterName"
    [get-modules]="$ctrl.getModules"
    [list-selected]="$ctrl.listSelected"
    [popover-is-open]="$ctrl.popoverIsOpen"
    [selected-module]="$ctrl.selectedModule"
    [title-text-key]="$ctrl.titleTextKey"
    [placeholder-text-key]="$ctrl.placeholderTextKey"
    (submit-filter)="$ctrl.submitFilter()"
    (toggle-module-value)="$ctrl.toggleModuleValue($event.value, $event.form, $event.event)"
    (toggle-value)="$ctrl.toggleValue($event.value, $event.form, $event.event)"></sis-search-filter-module>

  <search-filter-multi
    ng-switch-when="Multi"
    all-filters="$ctrl.allFilters"
    filter-matches-search-cb="$ctrl.filterMatchesSearch"
    filter-name="$ctrl.filterName"
    filter-search="$ctrl.filterSearch"
    filters-limit="$ctrl.filtersLimit"
    get-filter-index-cb="$ctrl.getFilterIndex"
    get-filter-name-cb="$ctrl.getFilterName"
    help-text="$ctrl.helpText"
    is-initialized="$ctrl.isInitialized"
    is-parent-filter-cb="$ctrl.isParentFilter"
    is-value-selected-cb="$ctrl.isValueSelected"
    list-selected="$ctrl.listSelected()"
    popover-is-open="$ctrl.popoverIsOpen"
    primary-filters="$ctrl.primaryFilters"
    searching="$ctrl.searching"
    search-within-filter="$ctrl.searchWithinFilter"
    secondary-filters="$ctrl.secondaryFilters"
    start-index="$ctrl.startIndex"
    submit-filter="$ctrl.submitFilter()"
    toggle-value-cb="$ctrl.toggleValue"></search-filter-multi>

  <search-filter-multi-with-headings
    ng-switch-when="MultiWithHeadings"
    all-filters="$ctrl.allFilters"
    filter-name="$ctrl.filterName"
    filter-search="$ctrl.filterSearch"
    filters-limit="$ctrl.filtersLimit"
    get-filter-index-cb="$ctrl.getFilterIndex"
    get-filter-name-cb="$ctrl.getFilterName"
    get-primary-filter-headings="$ctrl.getPrimaryFilterHeadings()"
    help-text="$ctrl.helpText"
    is-initialized="$ctrl.isInitialized"
    is-value-selected-cb="$ctrl.isValueSelected"
    list-selected="$ctrl.listSelected()"
    popover-is-open="$ctrl.popoverIsOpen"
    primary-filters-by-heading="$ctrl.primaryFiltersByHeading"
    searching="$ctrl.searching"
    search-within-filter="$ctrl.searchWithinFilter"
    start-index="$ctrl.startIndex"
    submit-filter="$ctrl.submitFilter()"
    toggle-value-cb="$ctrl.toggleValue"></search-filter-multi-with-headings>

  <sis-search-filter-organisation
    ng-switch-when="Organisation|OrganisationRoots"
    ng-switch-when-separator="|"
    [filter-name]="$ctrl.filterName"
    [get-filter-name]="$ctrl.getFilterName"
    [get-organisations]="$ctrl.getOrganisations"
    [help-text]="$ctrl.helpText"
    [list-selected]="$ctrl.listSelected"
    (open-organisation-modal)="$ctrl.openOrganisationDialog()"
    [popover-is-open]="$ctrl.popoverIsOpen"
    [selected-organisation]="$ctrl.selectedOrganisation"
    (submit-filter)="$ctrl.submitFilter()"
    (toggle-value)="$ctrl.toggleValue($event.value, $event.form, $event.event)"></sis-search-filter-organisation>

  <sis-search-filter-organisation
    ng-switch-when="StudyRightOrganisation|StudyRightParentOrganisation"
    ng-switch-when-separator="|"
    [filter-name]="$ctrl.filterName"
    [get-filter-name]="$ctrl.getFilterName"
    [get-organisations]="$ctrl.getOrganisations"
    [help-text]="$ctrl.helpText"
    [list-selected]="$ctrl.listSelected"
    (open-organisation-modal)="$ctrl.openOrganisationDialog('STUDY_RIGHT_ORGANISATION')"
    [popover-is-open]="$ctrl.popoverIsOpen"
    [selected-organisation]="$ctrl.selectedOrganisation"
    (submit-filter)="$ctrl.submitFilter()"
    (toggle-value)="$ctrl.toggleValue($event.value, $event.form, $event.event)"></sis-search-filter-organisation>

  <search-filter-range
    ng-switch-when="Range"
    help-text="$ctrl.helpText"
    popover-is-open="$ctrl.popoverIsOpen"
    selected-credits="$ctrl.selectedCredits"
    submit-range-filter="$ctrl.submitRangeFilter()"></search-filter-range>

  <search-filter-responsibility-infos
    ng-switch-when="ResponsibilityInfos"
    employee-service="$ctrl.employeeService"
    filter-name="$ctrl.filterName"
    get-selection-names="$ctrl.getSelectionNames()"
    help-text="$ctrl.helpText"
    popover-is-open="$ctrl.popoverIsOpen"
    submit-filter="$ctrl.submitFilter()"
    toggle-value-cb="$ctrl.toggleValue"></search-filter-responsibility-infos>

  <search-filter-single
    ng-switch-when="Single"
    filter-name="$ctrl.filterName"
    filter-search="$ctrl.filterSearch"
    filter-values="$ctrl.filterValues"
    get-filter-name-cb="$ctrl.getFilterName"
    help-text="$ctrl.helpText"
    popover-is-open="$ctrl.popoverIsOpen"
    search-within-filter="$ctrl.searchWithinFilter"
    set-value-cb="$ctrl.setValue"
    submit-filter="$ctrl.submitFilter()"></search-filter-single>
</div>
`;
export default template;
